// switch between development and production automatically
//export const isDev = window.location.href.indexOf("https://securema.ikea.com/") < 0;
export const isDev = false;

export const env = isDev ? "dev" : "prod";

console.log("Env: ", env);

export const apimKey = isDev ? "ecd8fa27001b48389263bf3df09f4b8c" : "ecd8fa27001b48389263bf3df09f4b8c";

export const merchant_identifier = isDev ? "pWGFtSLw" : "MjzvVjfH";
export const access_code = isDev ? "iS3ZJIfqSM5XTtnKzFpi" : "sYdawdp0GBLINYhIF9nh";

export const signature_url = isDev
  ? "https://dcbookingdev.azurewebsites.net/api/Signature"
  : "https://dcbooking.azurewebsites.net/api/Signature";

export const signature_key = isDev
  ? "XL9aWJDBc6KTpY/ZN/ITh09yLlW51Jdb523Zb98RrdCake9iwpKe6w=="
  : "goTdJMYTadhMWiKUIpcPLa96uLHIUcoKWD0Yg2Cz0gcvMvH3BEfnqA==";

export const checkout_free_url = isDev
  ? "https://dcbookingdev.azurewebsites.net/api/Summary"
  : "https://dcbooking.azurewebsites.net/api/Summary";

export const checkout_paid_url = isDev
  ? "https://sbcheckout.payfort.com/FortAPI/paymentPage"
  : "https://checkout.payfort.com/FortAPI/paymentPage";
